import { Module } from 'vuex';
import { mutations } from '@signing-page/integrations/store/integrations.mutations';
import { actions } from '@signing-page/integrations/store/integrations.actions';
import { IRootState } from '@signing-page/store/store';
import { IIntegration } from '@signing-page/integrations/types/integration';
import { twilio } from '@signing-page/integrations/twilio/store/twilio.store';

export const namespace: string = 'integrations';

export interface IIntegrationState {
  stripe?: IIntegration;
  stripeError: string;
  authorizeNet?: IIntegration;
  authorizeNetError: string;
}

export const state: IIntegrationState = {
  stripe: undefined,
  stripeError: '',
  authorizeNet: undefined,
  authorizeNetError: '',
};

const namespaced: boolean = true;

export const integrations: Module<IIntegrationState, IRootState> = {
  actions,
  namespaced,
  mutations,
  state,
  modules: {
    twilio,
  },
};
